import React, {useState} from 'react'
import ReactDOM from 'react-dom'
import {v4 as uuidV4} from 'uuid'
import {ConfigProvider} from 'antd'
import nbNO from 'antd/lib/locale-provider/nb_NO'
import moment from 'moment'
import {BrowserRouter} from 'react-router-dom'

import {PrivateRoutes, Login} from 'components'

import UserContext from 'shared/components/UserContext'
import RequestContext from 'shared/components/RequestContext'
import ErrorHandler from 'shared/components/ErrorHandler'
import AppWithAuth from 'shared/components/AppWithAuth'
import AuthenticatedApolloProvider from 'shared/components/AuthenticatedApolloProvider'
import useVersionCheck from 'shared/hooks/useVersionCheck'
import VersionNotification from 'shared/components/VersionNotification'
import createRaygunErrorReporter from 'shared/lib/errorReporterRaygun'

import GAListener from './GAListener'

import 'moment/locale/nb'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import './css/index.css'

const audience = 'serviceproviderapp'
const sessionId = uuidV4()

moment.locale('nb')

function App() {
  const [user, setUser] = useState({id: null, email: null})
  const { customFetch, hasNewVersion } = useVersionCheck()
  
  const errorReporter = createRaygunErrorReporter(user)

  return (
    <RequestContext.Provider value={{audience, sessionId}}>
      <UserContext.Provider value={user}>
        <ErrorHandler
          reporter={errorReporter}
          sessionId={sessionId}
          user={user}
        >
          <BrowserRouter>
            <AppWithAuth
              options={{
                jwtAud: audience,
                jwtKey: 'inviso-spa-jwt',
              }}
              components={{
                Login,
              }}
            >
              <ConfigProvider locale={nbNO}>
                <VersionNotification display={hasNewVersion} />
                <AuthenticatedApolloProvider customFetch={customFetch}>
                  <GAListener>
                    <PrivateRoutes setUser={setUser} />
                  </GAListener>
                </AuthenticatedApolloProvider>
              </ConfigProvider>
            </AppWithAuth>
          </BrowserRouter>
        </ErrorHandler>
      </UserContext.Provider>
    </RequestContext.Provider>
  )
}

ReactDOM.render(<App />, document.getElementById('root'))
